module.exports = __webpack_public_path__ + "static/media/spots-bg.9ee07573.png";